export default "__VITE_ASSET__BBghGc8p__"